import React from "react";
import { connect } from "react-redux"
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { reduxForm, formValueSelector, getFormSyncErrors } from 'redux-form'
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Col, FormGroup } from "react-bootstrap"
import moment from 'moment'
import { resetWizardState } from '../../../../redux/actions/action_postEvent';
import { blue, green, warning, gray, videoblue, StatusDescription } from '../../../../utils/constants'
import { STEP_SEQUENCE } from '../../logic';
import postEventManagementStyle from './../Styles/postEventManagementStyle'
import FeesPayment from './payment'
import CompleteEvent from './completedevent'

const formName = 'postevent'

class PayFees extends React.Component {
  constructor() {
    super();
    this.state = {
      paymentMode: false,
      completeMode: false,
      fees: [],
      totalPayments: 0,
      grandTotal: 0
    };

    this.handlePayment = this.handlePayment.bind(this);
    this.handleCompleteEvent = this.handleCompleteEvent.bind(this);
    this.calculateGrandTotal = this.calculateGrandTotal.bind(this);
    this.calculateTotalPayments = this.calculateTotalPayments.bind(this);
    this.mapFees = this.mapFees.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.dispatch(resetWizardState(STEP_SEQUENCE.FeePayment));
    this.mapFees();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mixedAgeDivisionsHeld !== this.props.mixedAgeDivisionsHeld) {
      this.mapFees();
    }
  }

  handlePayment() {
    this.setState({
      paymentMode: true
    })
  }

  handleCompleteEvent() {
    this.setState({
      completeMode: true
    })
  }

  calculateGrandTotal(fees) {
    if (fees.length > 0) {
      const grandTotal = fees.reduce(function (total, arr) {
        return total + arr.totalDue;
      }, 0);
      this.setState({
        grandTotal
      });
    }
  }

  calculateTotalPayments() {
    const { payments } = this.props;
    if (payments !== undefined && payments.length > 0) {
      const totalPayments = payments.reduce(function (total, arr) {
        return total + arr.amount;
      }, 0);
      this.setState({
        totalPayments
      });
    }
  }

  mapFees() {
    const { mixedAgeDivisionsHeld } = this.props;
    const fees = [];
    if (mixedAgeDivisionsHeld.length > 0) {
      let i;
      for (i = 0; i < mixedAgeDivisionsHeld.length; i++) {
        const divisions = mixedAgeDivisionsHeld[i].divisions;
        fees.push({
          divisionHeldName: mixedAgeDivisionsHeld[i].name,
          spotFee: Math.max.apply(Math, divisions.map(function (o) { return o.spotFee })),
          numberAdvancers: mixedAgeDivisionsHeld[i].numberAdvancers,
          totalDue: ((Math.max.apply(Math, divisions.map(function (o) { return o.spotFee })) !== null) ?
            Math.max.apply(Math, divisions.map(function (o) { return o.spotFee })) : 0) *
            ((mixedAgeDivisionsHeld[i].numberAdvancers !== null) ? mixedAgeDivisionsHeld[i].numberAdvancers : 0)
        });
      }
      this.setState({
        fees
      });

      this.calculateGrandTotal(fees);
      this.calculateTotalPayments();
    }
  }

  render() {
    const { paymentMode, completeMode, fees, totalPayments, grandTotal } = this.state;
    const { eventname, roleName, status, advancerEmailsSentOn } = this.props;

    const isAdministrator = roleName == 'Administrator';
    const paymentDue = (totalPayments - grandTotal).toFixed(2);
    const balanceColor = paymentDue >= 0 ? 'green' : 'red'

    let advancerEmailDate = '';

    if (advancerEmailsSentOn) {
      advancerEmailDate = moment(advancerEmailsSentOn, 'YYYY-MM-DD').format('LL');
    }

    return (
      <div style={{ marginTop: '1%' }} sm={6}>
        {
          !fees.length > 0 && !paymentMode && !completeMode && (
            <div sm={6}>
              <span style={{ color: videoblue, fontSize: '115%' }}>
                <i className="fa fa-info-circle" aria-hidden="true" />&nbsp;No divisions found
              </span>
            </div>
          )
        }
        {fees.length > 0 && !paymentMode && !completeMode && (
          <Col sm={12} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }}>
            <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
              <h4 className='text-left' style={{ color: blue }}>{' '}Event Name - {eventname}</h4>
              <h5 style={{ color: warning }} />
            </FormGroup>
            <Col sm={5}>
              <FormGroup>
                <ReactTable
                  data={fees}
                  columns={[
                    {
                      Header: "Division",
                      accessor: "divisionHeldName",
                      maxWidth: 105,
                      headerStyle: postEventManagementStyle.tableHeader
                    },
                    {
                      Header: "Cost/Spot",
                      accessor: "spotFee",
                      maxWidth: 90,
                      Cell: cellInfo => (
                        <span>&#36;{cellInfo.row.spotFee}</span>
                      ),
                      headerStyle: postEventManagementStyle.tableHeader
                    },
                    {
                      Header: "Advancers #",
                      accessor: "numberAdvancers",
                      maxWidth: 95,
                      headerStyle: postEventManagementStyle.tableHeader
                    },
                    {
                      Header: "Total Due",
                      accessor: "totalDue",
                      maxWidth: 65,
                      Cell: cellInfo => (
                        <span>&#36;{cellInfo.row.totalDue}</span>
                      ),
                      headerStyle: postEventManagementStyle.tableHeader
                    }
                  ]}
                  showPagination={false}
                  defaultPageSize={fees.length}
                  className="-striped -highlight"
                />
              </FormGroup>
              <div style={{ float: 'right' }}>
                <FormGroup style={{ marginTop: '10px' }}>
                  <p style={{ float: 'right', marginTop: '5px' }}><b>Grand Total:</b> <span> &nbsp;&nbsp;${grandTotal}</span></p>
                </FormGroup>
                <FormGroup>
                  <p style={{ float: 'right', marginTop: '5px' }}><b>Amount Paid:</b> <span> &nbsp;&nbsp;${totalPayments}</span></p>
                </FormGroup>
                <FormGroup>
                  <p style={{ float: 'right', marginTop: '5px' }}><b>Payment Due:</b> <span style={{ color: balanceColor, fontWeight: 'bold' }}> &nbsp;&nbsp;${paymentDue}</span></p>
                </FormGroup>
              </div>
              <FormGroup>
                <Col lgOffset={3} lg={12}>
                  {paymentDue < 0 &&
                    <button type='button' className="btn btn-default" style={{ fontWeight: 800, marginTop: '10px' }} onClick={this.handlePayment}>
                      <i className="fa fa-money" aria-hidden="true" /> &nbsp;&nbsp;Pay Fees
                        </button>
                  }
                  {paymentDue >= 0 &&
                    <button type='button' className="btn btn-default" style={{ fontWeight: 800, marginTop: '10px', marginLeft: '10px' }} onClick={this.handleCompleteEvent}
                      disabled={completeMode || !isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}>
                      <i className="fa fa-envelope" aria-hidden="true" style={{ color: green }} /> &nbsp;Send Advancer Emails
                        </button>
                  }
                  {status == StatusDescription.Completed && advancerEmailDate &&
                    (<span style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '15px' }}>
                      <i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;Advancer emails last sent on&nbsp; {advancerEmailDate}.
                    </span>)
                  }
                </Col>
              </FormGroup>
            </Col>
          </Col>)
        }
        {
          paymentMode &&
          <FeesPayment paymentDue={paymentDue} />
        }
        {
          completeMode &&
          <CompleteEvent paymentDue={paymentDue} />
        }
      </div>
    );
  }
}

PayFees.propTypes = {
  dispatch: PropTypes.func,
  eventname: PropTypes.string,
  mixedAgeDivisionsHeld: PropTypes.array,
  payments: PropTypes.array,
  roleName: PropTypes.string,
  status: PropTypes.string,
  //eventId: PropTypes.number,
  advancerEmailsSentOn: PropTypes.string
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form;
  const selector = formValueSelector(formName);
  const syncErrors = getFormSyncErrors(formName)(state)
  const eventId = selector(state, 'eventId')
  const eventname = selector(state, 'eventname');
  const feesPaid = selector(state, 'feesPaid');
  const mixedAgeDivisionsHeld = selector(state, 'mixedAgeDivisionsHeld');
  const payments = selector(state, 'payments');
  const roleName = state.user.roleName
  const status = selector(state, 'status')
  const advancerEmailsSentOn = selector(state, 'advancerEmailsSentOn')
  return {
    syncErrors,
    eventId,
    eventname,
    feesPaid,
    mixedAgeDivisionsHeld,
    payments,
    roleName,
    status,
    advancerEmailsSentOn
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    resetWizardState
  }, dispatch)
}

export default reduxForm({
  form: formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(PayFees))


// WEBPACK FOOTER //
// ./src/containers/postevent/components/fees/index.js